









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import {
  adminContentItemResourceFinancialTableColumns
} from '@/modules/content-item/models/columns/admin-content-item-resource-financial-table.column'
import { isDef } from '@/modules/shared/helpers/utils/utils'
import { Prop } from 'vue-property-decorator'
import AdminContentItemFinancialTableRow
  from '@/modules/content-item/components/admin/table/AdminContentItemFinancialTableRow.vue'
import { ContentItemResourceModel } from '@/modules/content-item/models/content-item-resource.model'

@Component({
  components: {
    TesTable
  }
})
export default class AdminContentItemFinancialTable extends Vue {
  @Prop({ required: true }) contentItemResource: ContentItemResourceModel

  rowComponent = AdminContentItemFinancialTableRow

  get columns() {
    const cols = adminContentItemResourceFinancialTableColumns()
    if (isDef(this.contentItemResource.profit)) {
      return cols
    }
    return cols.filter(col => col.field !== 'profit')
  }
}
